import React, { useContext } from "react";
import { AppContext, Tab } from "./AppContext";

import selectedtab from "../img/highlight.svg";
import star from "../img/star.svg";
import starburst from "../img/starburst.svg";
import diamond from "../img/diamond.svg";

const TAB_MAPPING = [
  {
    label: "Venues",
    value: Tab.VENUES,
    selectedTabSvg: star,
  },
  {
    label: "Plan tour",
    value: Tab.ROUTE,
    selectedTabSvg: starburst,
  },
  {
    label: "Info",
    value: Tab.ABOUT,
    selectedTabSvg: diamond,
  },
];

export const Tabs: React.FC = () => {
  const { tab, setTab } = useContext(AppContext);

  return (
    <div className="menu container-margin my-2 py-1 border-t border-b border-black dm-sans flex">
      {TAB_MAPPING.map((tabConfig, i) => {
        return (
          <div
            className="justify-left mr-4 md:mr-6 flex text-sm sm:text-base md:text-md flex-grow md:flex-shrink"
            key={i}
          >
            <img
              src={tabConfig.selectedTabSvg}
              className={`z-20 h-4 md:h-5 mr-2 my-1 transition-opacity ${
                tab === tabConfig.value ? "opacity-100" : "opacity-20"
              }`}
              alt="Tab selected"
              style={{}}
            />
            <button
              onClick={() => setTab(tabConfig.value)}
              className={`my-1 font-bold uppercase z-30`}
            >
              {tabConfig.label}
            </button>
          </div>
        );
      })}
    </div>
  );
};
